/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cookie_PreferencesInputs */

const en_cookie_preferences = /** @type {(inputs: Cookie_PreferencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preferences`)
};

const es_cookie_preferences = /** @type {(inputs: Cookie_PreferencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preferencias`)
};

const fr_cookie_preferences = /** @type {(inputs: Cookie_PreferencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Préférences`)
};

/**
* | output |
* | --- |
* | "Preferences" |
*
* @param {Cookie_PreferencesInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const cookie_preferences = /** @type {((inputs?: Cookie_PreferencesInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cookie_PreferencesInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cookie_preferences(inputs)
	if (locale === "es") return es_cookie_preferences(inputs)
	return fr_cookie_preferences(inputs)
});